
import _ from "lodash";
import baseDataService from "../../core/services/dataservice/dataservice.base";
import dataservice from "../../core/services/dataservice";

export const useUserStore = defineStore("user", {
    state: () => {
        return {
            users: [],            
            user:{}
        };
    },

    actions: {
        async init() {          
            await this.getUsers();
            const user = this.getCurrentUser()
            this.user = user

        },
        getCurrentUser() {            
            const authStore = useAuthStore()
            return this.users.find(f=>f.key1== authStore.uid)            
        },        

        async createUser(email:string, password:string, role:string, lang:string){
            const shopStore = useShopStore()
            try {
                await new baseDataService('/users/stores').post({email, password, role, lang, storeId:shopStore.storeId});
                await this.getUsers();
            } catch (error) {
                console.log(error)
            }            
        },
        async getUsers(){
            try {
                const shopStore = useShopStore()
                const res = await new baseDataService('/users/stores').getById(shopStore.storeId);
                const sorted = res.data.sort(function(a:string, b:string) {
                    return new Date(a.createdDate) - new Date(b.createdDate);
                });

                const sorted2 = sorted.filter((item) => item.role !== 'support');

                // let mockLang = sorted.map((item) => {
                //     return {
                //         ...item,
                //         lang: "en",
                //     };
                // });
                this.users =  sorted2
                return sorted2
            } catch (error) {
                return null
                console.log(error)
            }
            
        },
        async editUser(data:object){
            try {           
                const shopStore = useShopStore()
                const payload ={
                    ...data,                    
                    storeId:shopStore.storeId
                }
           
                const response = await new baseDataService(`users/${payload.uid}`).put(payload);
                return response.data;
               
            } catch (error) {
                console.log(error)
            }
            
        },
        async changePassword(password){
            try {
                const authStore = useAuthStore()
                const payload ={
                    password,
                    uid:authStore.uid
                }

                console.log("payload", payload)
                const response = await dataservice.main.changePassword(payload);
                return response.data;
               
            } catch (error) {
                console.log(error)
            }
            
        },
        async removeUser(data:object){
            try {
                await new baseDataService('/users/stores').delete(data);
                await this.getUsers();
            } catch (error) {
                console.log(error)
            }
        },

    }
})
